import { render, staticRenderFns } from "./pi-model-add.vue?vue&type=template&id=b9cb9cc6"
import script from "./pi-model-add.vue?vue&type=script&lang=ts"
export * from "./pi-model-add.vue?vue&type=script&lang=ts"
import style0 from "./pi-model-add.vue?vue&type=style&index=0&id=b9cb9cc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports